import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@shared/ui';

interface ReconciliationListControlsProps {
  children: ReactNode;
  onApply: () => void;
  onReset?: () => void;
}

export function ReconciliationListControls({ children, onApply, onReset }: ReconciliationListControlsProps) {
  const { t } = useTranslation('cabinet');

  return (
    <div className="space-y-3">
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">{children}</div>
      <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        <Button type="button" size="sm" variant="secondary" className="w-full sm:w-auto" onClick={onApply}>
          {t('reconciliation.filters.apply')}
        </Button>
        {onReset ? (
          <Button type="button" size="sm" variant="outline" className="w-full sm:w-auto" onClick={onReset}>
            {t('reconciliation.filters.reset')}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
